import {
  List, Datagrid, TextField, DateField, EditButton, Edit, Create, SimpleForm,
  TextInput, NumberInput, DateInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';

const EventList = () => (
  <List sort={{ field: 'eventDate', order: 'DESC' }} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="title" />
      <DateField source="eventDate" label="Date" />
      <TextField source="location" />
      <EditButton />
    </Datagrid>
  </List>
);

const EventForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 800 }}>
    <TextInput source="title" validate={required()} fullWidth />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <DateInput source="eventDate" label="Event date" validate={required()} />
      <TextInput source="startTime" label="Start time (e.g. 09:00)" />
      <TextInput source="endTime" label="End time (e.g. 17:00)" />
    </Stack>
    <TextInput source="location" fullWidth />
    <TextInput source="description" multiline minRows={4} fullWidth />
    <ImageUploadInput source="image" label="Event image" />
    <NumberInput source="sortOrder" defaultValue={0} />
  </Stack>
);

const EventEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><EventForm /></SimpleForm>
  </Edit>
);
const EventCreate = () => (
  <Create redirect="list">
    <SimpleForm><EventForm /></SimpleForm>
  </Create>
);

export default {
  list: EventList,
  edit: EventEdit,
  create: EventCreate,
  icon: EventIcon,
  options: { label: 'Events' },
  recordRepresentation: 'title',
};
